import { Component, OnInit } from '@angular/core';
import { Contact } from "app/shared/shared.module";

import { AuthenticationService } from "app/brightserve/authentication.service";
import { Address } from "app/common/address";

import { SlimScrollOptions } from "app/shared/shared.module";
import { DashboardService } from "app/dashboard/dashboard.service";
import { Subscription } from "rxjs/Subscription";

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

	SlimScrollOptions = SlimScrollOptions;
	RecentActivityLoading: boolean = false;

	Step: number = 50;
	Duration: number = 0.5;

    HeadingBoxes : any = [];
    RecentActivities: any = [];

    GetDashboardSubscription: Subscription;

    constructor(private dashboardService: DashboardService, private authenticationService: AuthenticationService) { }

    ngOnInit() {
        this.GetDashboardSubscription = this.dashboardService.GetDashboard().subscribe((res) => {
            console.log("Got dashboard");
            console.log(res);
            this.HeadingBoxes = res.HeadingBoxes;
            this.RecentActivities = res.RecentActivities;
            var headingBoxStyle = "col-lg-" + (12 / this.HeadingBoxes.length);
            this.HeadingBoxes.forEach(function (box) {
                box.style = headingBoxStyle;
                box.countto = null;
            });
        });

    }

    ngOnDestory() {
        this.GetDashboardSubscription.unsubscribe();
    }

	onScroll() {
		//this.RecentActivityLoading = true;
		//console.log('scrolled!!')
	}
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts